import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  overflow: hidden;
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const StyleSelectBox = styled.select`
  height: 32px;
  margin-left: 5px;
  width: 100%;
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  option {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
export const SelectBoxWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  padding: 10px 5px;
`;
export const UpdateButtonDiv = styled.div`
  width: 90%;
  margin-left: 16px;
  padding: 30px 0;
`;
export const ContentWrapper = styled.div`
  width: 70%;
  height: auto;
  background-color: ${ColorSF2.white};
`;
export const SectionWrapper = styled.div`
  width: 90%;
  margin: 16px;
  padding-top: 30px;
`;
export const SectionTitle = styled.p`
  margin-bottom: 9px;
  font-weight: bold;
`;
export const FlexRow = styled.div`
  display: flex;
`;
export const AutoOverflowContainer = styled.div`
  overflow-y: auto;
  height: 100%;
`;
